import { useState, useEffect } from 'react';
import ImagePreviewModal from '../Modal/ImagePreviewModal';
import { refreshScreenshotUrl } from '../../utils/screenshotUtils';

/**
 * Image preview with S3 presigned URL refresh when the link expires.
 */
export default function ScreenshotImagePreviewModal({
    open = false,
    onClose,
    imageUrl = null,
    fileName = 'Screenshot',
    rawPath = null,
}) {
    const [resolvedUrl, setResolvedUrl] = useState(imageUrl);

    useEffect(() => {
        if (open) {
            setResolvedUrl(imageUrl);
        }
    }, [open, imageUrl]);

    return (
        <ImagePreviewModal
            open={open}
            onClose={onClose}
            imageUrl={resolvedUrl}
            fileName={fileName}
            onImageError={async () => {
                if (!rawPath) return null;
                const { url } = await refreshScreenshotUrl(rawPath);
                if (url) {
                    setResolvedUrl(url);
                    return url;
                }
                return null;
            }}
        />
    );
}
